export const CANDIDATES_TEMPLATE_FILE_PATH = encodeURI("/files/Шаблон загрузки кандидатов.xlsx");

export const ADD_CANDIDATES_URL = "examination/add-candidates-from-xlsx";

export const COMPANY_CANDIDATE_UPLOAD_URL = "company-candidate/upload-from-xlsx";
